module.exports = __webpack_public_path__ + "img/2. about.78dc9ecb.png";